import { StandardEvents } from '@shopify/events';
import { coverage, distanceKm, pinCoverage } from '@sanjar/delivery-area';
class SanjarNavigation extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController(); const { signal } = this.abort;
    this.menu = this.querySelector('#SanjarMenu'); this.delivery = this.querySelector('[data-sl-delivery-dialog]');
    this.stores = this.querySelector('[data-sl-stores-dialog]');
    this.storeLabels = this.stores ? JSON.parse(this.stores.querySelector('[data-sl-stores-labels]').textContent) : {};
    this.labels = this.delivery ? JSON.parse(this.delivery.querySelector('[data-sl-delivery-labels]').textContent) : {};
    this.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('button'); if (!trigger) return;
      if (trigger.matches('[data-sl-menu-open]')) this.open(this.menu, trigger);
      if (trigger.matches('[data-sl-menu-close]')) this.menu?.close();
      if (trigger.matches('[data-sl-delivery-open]')) { this.menu?.close(); this.open(this.delivery, trigger.closest('dialog') ? this.querySelector('[data-sl-menu-open]') : trigger); }
      if (trigger.matches('[data-sl-stores-open]')) { this.menu?.close(); this.open(this.stores, trigger.closest('dialog') ? this.querySelector('[data-sl-menu-open]') : trigger); }
      if (trigger.matches('[data-sl-stores-close]')) this.stores?.close();
      if (trigger.matches('[data-sl-stores-location]')) this.locateStores(trigger);
      if (trigger.matches('[data-sl-delivery-close]')) this.delivery?.close();
      if (trigger.matches('[data-sl-open]')) this.menu?.close();
      if (trigger.matches('[data-sl-location]')) this.locate(trigger);
      if (trigger.matches('[data-sl-delivery-request]')) this.saveDelivery(true, trigger);
      if (trigger.matches('[data-sl-delivery-standard]')) this.saveDelivery(false, trigger);
    }, { signal });
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element) || this.contains(event.target)) return;
      const trigger = event.target.closest('[data-sl-delivery-open], [data-sl-stores-open]');
      if (trigger) { this.menu?.close(); this.open(trigger.hasAttribute('data-sl-stores-open') ? this.stores : this.delivery, trigger); }
    }, { signal });
    [this.menu, this.delivery, this.stores].filter(Boolean).forEach(dialog => {
      dialog.addEventListener('close', () => { this.sync(); this.opener?.focus({ preventScroll: true }); }, { signal });
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      }, { signal });
    });
    this.querySelector('[data-sl-pin-form]')?.addEventListener('submit', async event => {
      event.preventDefault(); this.areaRequest = (this.areaRequest || 0) + 1; this.querySelector('[data-sl-location]').disabled = false;
      const pin = new FormData(event.target).get('pin')?.toString().trim();
      const pins = this.delivery.dataset.pins.split(/[\s,;]+/).filter(code => /^[1-9][0-9]{5}$/.test(code));
      this.checkedPin = pin; this.checkMethod = 'PIN code';
      if (!/^[1-9][0-9]{5}$/.test(pin || '')) { this.result('invalid'); return; }
      const request = this.areaRequest;
      if (pins.includes(pin)) { this.result('inside'); return; }
      this.result('locating');
      try {
        this.pinData ||= await fetch(this.delivery.dataset.pinData, { signal }).then(response => { if (!response.ok) throw new Error(); return response.json(); });
        if (request !== this.areaRequest || !this.isConnected) return;
        this.result(pinCoverage(pin, this.pinData, Number(this.delivery.dataset.lat), Number(this.delivery.dataset.lng), Number(this.delivery.dataset.radius)));
      } catch { if (request === this.areaRequest) this.result('unknown'); }
    }, { signal });
    document.addEventListener(StandardEvents.cartLinesUpdate, event => {
      event.promise?.then(({ cart, detail }) => { if (!this.isConnected) return; const count = cart?.totalQuantity ?? detail?.itemCount; const badge = this.querySelector('[data-sl-bag-count]'); if (count !== undefined && badge) badge.textContent = String(count); }).catch(() => {});
    }, { signal });
    this.resize = new ResizeObserver(() => { const header = this.querySelector('.sl-nav-header'); document.body.style.setProperty('--header-height', `${header.offsetHeight}px`); document.body.style.setProperty('--header-group-height', `${this.offsetHeight}px`); }); this.resize.observe(this);
    this.lastScroll = window.scrollY; this.scrollPending = false;
    window.addEventListener('scroll', () => {
      if (this.scrollPending || this.dataset.scrollMode !== 'reveal') return;
      this.scrollPending = true; requestAnimationFrame(() => {
        this.scrollPending = false; if (!this.isConnected) return;
        const position = Math.max(0, window.scrollY), delta = position - this.lastScroll;
        if (Math.abs(delta) > 5) { this.classList.toggle('sl-header-hidden', delta > 0 && position > this.offsetHeight && !this.menu?.open && !this.delivery?.open && !this.stores?.open && !document.querySelector('dialog[open]')); this.lastScroll = position; }
      });
    }, { signal, passive: true });
    this.sync();
  }
  disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); this.menu?.close(); this.delivery?.close(); this.stores?.close(); this.storeRequest = (this.storeRequest || 0) + 1; this.areaRequest = (this.areaRequest || 0) + 1; this.sync(); }
  open(dialog, trigger) { if (!dialog || dialog.open) return; this.opener = trigger; this.classList.remove('sl-header-hidden'); dialog.showModal(); this.sync(); }
  sync() {
    this.querySelectorAll('[data-sl-menu-open]').forEach(button => button.setAttribute('aria-expanded', String(!!this.menu?.open)));
    document.documentElement.classList.toggle('sl-navigation-open', !!this.menu?.open || !!this.delivery?.open || !!this.stores?.open);
  }
  result(state) {
    this.eligible = state === 'inside';
    const readyProducts = this.delivery.querySelector('[data-sl-ready-products]');
    if (readyProducts) readyProducts.hidden = !this.eligible;
    this.delivery.querySelector('[data-sl-delivery-status]').textContent = this.labels[state] || this.labels.unavailable;
    this.delivery.querySelector('[data-sl-delivery-request]').hidden = !this.eligible;
  }
  locate(button) {
    const request = this.areaRequest = (this.areaRequest || 0) + 1;
    this.checkMethod = 'Device location'; this.checkedPin = ''; this.result('locating'); button.disabled = true;
    const finish = state => { if (!this.isConnected || request !== this.areaRequest) return; button.disabled = false; this.result(state); };
    if (!navigator.geolocation) { finish('unavailable'); return; }
    navigator.geolocation.getCurrentPosition(position => finish(coverage(position.coords.latitude, position.coords.longitude, position.coords.accuracy, Number(this.delivery.dataset.lat), Number(this.delivery.dataset.lng), Number(this.delivery.dataset.radius))), () => finish('unavailable'), { enableHighAccuracy: true, timeout: 12000, maximumAge: 0 });
  }
  locateStores(button) {
    const status = this.stores.querySelector('[data-sl-stores-status]');
    const stores = [...this.stores.querySelectorAll('[data-sl-store]')];
    const valid = stores.filter(store => store.dataset.lat.trim() && store.dataset.lng.trim() && Number.isFinite(Number(store.dataset.lat)) && Number.isFinite(Number(store.dataset.lng)) && Math.abs(Number(store.dataset.lat)) <= 90 && Math.abs(Number(store.dataset.lng)) <= 180);
    if (!valid.length) { status.textContent = this.storeLabels.pending; return; }
    const request = this.storeRequest = (this.storeRequest || 0) + 1;
    button.disabled = true; status.textContent = this.storeLabels.checking;
    const fail = () => { if (!this.isConnected || request !== this.storeRequest) return; button.disabled = false; status.textContent = this.storeLabels.denied; };
    if (!navigator.geolocation) { fail(); return; }
    navigator.geolocation.getCurrentPosition(position => {
      if (!this.isConnected || request !== this.storeRequest) return;
      if (![position.coords.latitude, position.coords.longitude].every(Number.isFinite)) { fail(); return; }
      stores.forEach(store => {
        store.distance = valid.includes(store) ? distanceKm(position.coords.latitude, position.coords.longitude, Number(store.dataset.lat), Number(store.dataset.lng)) : Infinity;
        const label = store.querySelector('[data-sl-store-distance]'); label.hidden = !Number.isFinite(store.distance);
        if (!label.hidden) label.textContent = this.storeLabels.distance.replace('__distance__', store.distance.toFixed(1));
      });
      stores.sort((a,b) => a.distance - b.distance).forEach(store => this.stores.querySelector('[data-sl-store-list]').append(store));
      button.disabled = false; status.textContent = this.storeLabels.nearest;
    }, fail, { enableHighAccuracy: false, timeout: 12000, maximumAge: 60000 });
  }
  async saveDelivery(express, button) {
    if (express && !this.eligible || this.saving) return;
    this.saving = true; button.disabled = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Sanjar delivery request': express ? 'Bangalore 60-minute delivery — confirmation required' : '', 'Sanjar delivery area': express ? `Within ${this.delivery.dataset.radius} km of Majestic` : '', 'Sanjar delivery PIN': express ? this.checkedPin || 'Location checked' : '', 'Sanjar delivery check': express ? this.checkMethod || 'Area checked' : '' } }), signal: this.abort.signal });
      if (!response.ok) throw new Error('Cart update failed'); await response.json();
      try { if (express) sessionStorage.setItem('sanjar-express-request', JSON.stringify({ pin: this.checkedPin || '', method: this.checkMethod || 'Area checked' })); else sessionStorage.removeItem('sanjar-express-request'); } catch {}
      this.delivery.querySelector('[data-sl-delivery-status]').textContent = this.labels[express ? 'saved' : 'standard'];
    } catch (error) { if (error.name !== 'AbortError') this.delivery.querySelector('[data-sl-delivery-status]').textContent = this.labels.error; }
    finally { this.saving = false; button.disabled = false; }
  }
}
if (!customElements.get('sl-navigation')) customElements.define('sl-navigation', SanjarNavigation);

class SlCategoryMenu extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    const tabs = this.querySelector('.sl-category-tabs');
    const groups = [...this.querySelectorAll('.sl-menu-groups > details')];
    if (!tabs || !groups.length) return;
    if (this.dataset.defaultLayout === 'list') { this.classList.add('is-list'); return; }
    tabs.replaceChildren();
    const uid = this.closest('[id]')?.id || `menu-${Math.random().toString(36).slice(2,8)}`;
    let selected = 0;
    const select = index => {
      selected = index;
      groups.forEach((panel, position) => {
        panel.hidden = position !== index;
        const button = tabs.children[position]; button.setAttribute('aria-selected', String(position === index)); button.tabIndex = position === index ? 0 : -1;
      });
      this.querySelector('.sl-menu-groups').scrollTop = 0;
    };
    const layout = mode => {
      const visual = mode !== 'list';
      this.classList.toggle('is-ready', visual); this.classList.toggle('is-list', !visual);
      this.querySelectorAll('[data-menu-layout]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.menuLayout === (visual ? 'visual' : 'list'))));
      groups.forEach((panel, index) => {
        const summary = panel.querySelector('summary'); summary.hidden = visual;
        panel.hidden = false; panel.open = visual || index === selected;
        if (visual) { panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',tabs.children[index].id); }
        else { panel.removeAttribute('role'); panel.removeAttribute('aria-labelledby'); }
      });
      if (visual) select(selected);
    };
    groups.forEach((panel, index) => {
      const summary = panel.querySelector('summary');
      const button = document.createElement('button'); button.type = 'button';
      button.textContent = summary.firstChild.textContent.trim();
      button.id = `${uid}-CategoryTab-${index}`; panel.id = `${uid}-CategoryPanel-${index}`;
      button.setAttribute('role', 'tab'); button.setAttribute('aria-controls', panel.id); tabs.append(button);
      button.addEventListener('click', () => select(index), { signal: this.abort.signal });
      button.addEventListener('keydown', event => {
        let target = index;
        if (event.key === 'ArrowDown') target = (index + 1) % groups.length;
        else if (event.key === 'ArrowUp') target = (index + groups.length - 1) % groups.length;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = groups.length - 1;
        else return;
        event.preventDefault(); select(target); tabs.children[target].focus();
      }, { signal: this.abort.signal });
    });
    this.querySelectorAll('[data-menu-layout]').forEach(button => button.addEventListener('click', () => layout(button.dataset.menuLayout), {signal:this.abort.signal}));
    layout(this.dataset.defaultLayout);
  }
  disconnectedCallback() { this.abort?.abort(); }
}
if (!customElements.get('sl-category-menu')) customElements.define('sl-category-menu', SlCategoryMenu);
